<div class="new-content" *ngIf="false else contentBlock">
  <loading-line height="40px" width="100%"></loading-line>
</div>
<ng-template #contentBlock>
  <div class="statistic-informer">
    <app-library-title [title]="blockTitle">
        <ng-container right>
          <ng-template [ngIf]="isTeacher && !deviceService.isMobile()">
            <a routerLink="/constructor" class="create-content normal">
              {{ 'statistic-informer.create-content' | customLocale }}
            </a>
          </ng-template>
        </ng-container>
      <ng-container side>
        <span class="content-type normal">
          {{ (isTeacher ? 'statistic-informer.subtitle' : 'statistic-informer.subtitle-student') | customLocale }}
        </span>
      </ng-container>

      <ng-container side2>
        <ng-template [ngIf]="isTeacher && deviceService.isMobile()">
          <a routerLink="/constructor" class="create-content normal">
            {{ 'statistic-informer.create-content' | customLocale }}
          </a>
        </ng-template>
      </ng-container>
    </app-library-title>

    <div class="informer">
      <div class="item-wrap">
        <div class="icon-wrap lesson">
          <app-icon width="23" height="16" icon="informer-lesson"></app-icon>
        </div>
        <div class="label-wrap">
          <span class="label normal"
                [innerHTML]="(isTeacher ? 'statistic-informer.lesson' : 'statistic-informer.lesson-student') | customLocale">
          </span>
        </div>

        <span class="value bold">{{ pane.stats?.lessons }}</span>
      </div>

      <div class="item-wrap">
        <div class="icon-wrap subject">
          <app-icon width="22" height="24" icon="informer-subject"></app-icon>
        </div>
        <div class="label-wrap">
          <span class="label normal" [innerHTML]="'statistic-informer.subject' | customLocale"></span>
        </div>
        <span class="value bold">{{ pane.stats?.disciplines }}</span>
      </div>

      <div class="item-wrap">
        <div class="icon-wrap teachers">
          <app-icon width="14" height="22" icon="informer-teachers"></app-icon>
        </div>
        <div class="label-wrap">
          <span class="label normal" [innerHTML]="'statistic-informer.teachers' | customLocale"></span>
        </div>
        <span class="value bold">{{ pane.stats?.teachers }}</span>
      </div>
    </div>
  </div>
</ng-template>
